export class EnhancedError extends Error {
    constructor(message, extraData = {}) {
        super(message);
        this.extraData = extraData;
        this.name = 'EnhancedError';
    }
}
//# sourceMappingURL=EnhancedError.js.map